"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fonts_1 = require("../../global/fonts");
const typography = {
    large: {
        mini: {
            ...fonts_1.SourceSansProRegular,
            size: 14,
            lineHeight: 20,
        },
        miniBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 14,
            lineHeight: 20,
        },
        caption: {
            ...fonts_1.SourceSansProRegular,
            size: 14,
            lineHeight: 20,
        },
        captionBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 14,
            lineHeight: 20,
        },
        body: {
            ...fonts_1.SourceSansProRegular,
            size: 16,
            lineHeight: 24,
        },
        bodyBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 16,
            lineHeight: 24,
        },
        lead: {
            ...fonts_1.ProximaNovaRegular,
            size: 18,
            lineHeight: 24,
        },
        overline: {
            ...fonts_1.ProximaNovaSemibold,
            size: 14,
            lineHeight: 18,
            textTransform: 'uppercase',
        },
        displaySmall: {
            ...fonts_1.ProximaNovaSemibold,
            size: 20,
            lineHeight: 28,
        },
        subheading: {
            ...fonts_1.ProximaNovaSemibold,
            size: 18,
            lineHeight: 24,
        },
        displayMedium: {
            ...fonts_1.ProximaNovaSemibold,
            size: 28,
            lineHeight: 36,
        },
        heading: {
            ...fonts_1.ProximaNovaSemibold,
            size: 24,
            lineHeight: 28,
        },
        pageheading: {
            ...fonts_1.ProximaNovaRegular,
            size: 32,
            lineHeight: 36,
        },
        displayLarge: {
            ...fonts_1.ProximaNovaSemibold,
            size: 40,
            lineHeight: 52,
        },
        callout: {
            ...fonts_1.ProximaNovaRegular,
            size: 18,
            lineHeight: 24,
        },
        code: {
            ...fonts_1.CourierNewBold,
            size: 18,
            lineHeight: 24,
        },
    },
    regular: {
        mini: {
            ...fonts_1.SourceSansProRegular,
            size: 14,
            lineHeight: 20,
        },
        miniBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 14,
            lineHeight: 20,
        },
        caption: {
            ...fonts_1.SourceSansProRegular,
            size: 14,
            lineHeight: 20,
        },
        captionBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 14,
            lineHeight: 20,
        },
        body: {
            ...fonts_1.SourceSansProRegular,
            size: 16,
            lineHeight: 24,
        },
        bodyBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 16,
            lineHeight: 24,
        },
        lead: {
            ...fonts_1.ProximaNovaRegular,
            size: 18,
            lineHeight: 24,
        },
        overline: {
            ...fonts_1.ProximaNovaSemibold,
            size: 14,
            lineHeight: 18,
            textTransform: 'uppercase',
        },
        displaySmall: {
            ...fonts_1.ProximaNovaSemibold,
            size: 20,
            lineHeight: 28,
        },
        subheading: {
            ...fonts_1.ProximaNovaSemibold,
            size: 18,
            lineHeight: 24,
        },
        displayMedium: {
            ...fonts_1.ProximaNovaSemibold,
            size: 28,
            lineHeight: 36,
        },
        heading: {
            ...fonts_1.ProximaNovaSemibold,
            size: 24,
            lineHeight: 28,
        },
        pageheading: {
            ...fonts_1.ProximaNovaRegular,
            size: 32,
            lineHeight: 36,
        },
        displayLarge: {
            ...fonts_1.ProximaNovaSemibold,
            size: 40,
            lineHeight: 52,
        },
        callout: {
            ...fonts_1.ProximaNovaRegular,
            size: 18,
            lineHeight: 24,
        },
        code: {
            ...fonts_1.CourierNewBold,
            size: 18,
            lineHeight: 24,
        },
    },
    compact: {
        mini: {
            ...fonts_1.SourceSansProRegular,
            size: 14,
            lineHeight: 20,
        },
        miniBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 14,
            lineHeight: 20,
        },
        caption: {
            ...fonts_1.SourceSansProRegular,
            size: 14,
            lineHeight: 20,
        },
        captionBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 14,
            lineHeight: 20,
        },
        body: {
            ...fonts_1.SourceSansProRegular,
            size: 16,
            lineHeight: 24,
        },
        bodyBold: {
            ...fonts_1.SourceSansProSemiBold,
            size: 16,
            lineHeight: 24,
        },
        lead: {
            ...fonts_1.ProximaNovaRegular,
            size: 18,
            lineHeight: 24,
        },
        overline: {
            ...fonts_1.ProximaNovaSemibold,
            size: 14,
            lineHeight: 18,
            textTransform: 'uppercase',
        },
        displaySmall: {
            ...fonts_1.ProximaNovaSemibold,
            size: 20,
            lineHeight: 24,
        },
        subheading: {
            ...fonts_1.ProximaNovaSemibold,
            size: 18,
            lineHeight: 24,
        },
        displayMedium: {
            ...fonts_1.ProximaNovaSemibold,
            size: 24,
            lineHeight: 32,
        },
        heading: {
            ...fonts_1.ProximaNovaSemibold,
            size: 22,
            lineHeight: 28,
        },
        pageheading: {
            ...fonts_1.ProximaNovaRegular,
            size: 24,
            lineHeight: 28,
        },
        displayLarge: {
            ...fonts_1.ProximaNovaSemibold,
            size: 36,
            lineHeight: 40,
        },
        callout: {
            ...fonts_1.ProximaNovaRegular,
            size: 18,
            lineHeight: 24,
        },
        code: {
            ...fonts_1.CourierNewBold,
            size: 18,
            lineHeight: 24,
        },
    },
};
exports.default = typography;
//# sourceMappingURL=typography.js.map